<template>
    <router-view :config="config" />
  </template>
  
  <script>
  export default {
    name: "index",
    props: {
        config: Object
    },
  };
  </script>
  